export default __webpack_public_path__ + "static/media/fritadeira_compact_line.4bebd7cf.png";